import * as actionTypes from "../actionTypes";
import {updateObject} from "../../shared/utils/updateObject";
import {
    initialActiveServiceRequestState,
    initialCollaboratorsState,
    initialDeviceSelectedRowState,
    initialDeviceState,
    initialDeviceSuggestionState,
    initialFilterDataState,
    initialFilterState,
    initialKaskoDataState
} from "./helper";

const initialState = {
    device: initialDeviceState,
    filter: initialFilterState,
    filterData: initialFilterDataState,
    filterClicked: false,
    deviceSelectedRow: initialDeviceSelectedRowState,
    deviceSuggestion: initialDeviceSuggestionState,
    activeServiceRequest: initialActiveServiceRequestState,
    collaborators: initialCollaboratorsState,
    downloadCsvLoading: false,
    kaskoData: initialKaskoDataState
};

const setDeviceData = (state, action) => {
    const tmpObject = {
        ...state.device,
        data: action.response.data,
        count: action.response.count,
        rowsPerPage: action.rowsPerPage,
        page: action.response.pageNumber,
    };
    return updateObject(state, {device: tmpObject});
}

const setLoadingDevices = (state, action) => {
    let tmpObject = {
        ...state.device,
        loading: action.value
    }
    if (action.value) {
        tmpObject = {...tmpObject, count: 0}
    }
    return updateObject(state, {device: tmpObject})
}

const setLoadingDeviceDetails = (state, action) => {
    let tmpObject = {
        ...state.deviceSelectedRow,
        loading: action.value
    }
    return updateObject(state, {deviceSelectedRow: tmpObject})
}

const setSelectedDevice = (state, action) => {
    return updateObject(state, {deviceSelectedRow: action.device})
}

const setSortingDevice = (state, action) => {
    return updateObject(state, {
        device: {
            ...state.device,
            sorting: action.value
        }
    })
}

const changeFilter = (state, action) => {
    let tmpFilter;
    let updatedFilter;
    if (action.date === "") {
        tmpFilter = {...state.filter[`${action.name}`], value: action.value, text: action.text};
    } else {
        tmpFilter = {...state.filter[`${action.name}`], [`${action.date}`]: action.value};
    }
    updatedFilter = {...state.filter, [`${action.name}`]: action.date === "r" ? action.value : tmpFilter};
    return updateObject(state, {filter: updatedFilter});
};

const resetFilter = (state, action) => {
    return updateObject(state, {filter: action.payload});
};
const setFilterClicked = (state, action) => {
    return updateObject(state, {filterClicked: action.val});
};

const setFilterLoadingOrError = (state, action) => {
    return updateObject(state, {filterData: {...state.filterData, [`${action.label}`]: action.value}});
}

const setFilterInputData = (state, action) => {
    return updateObject(state, {filterData: {...state.filterData, ...action.response}})
}

const updateModelloSelect = (state, action) => {
    return updateObject(state, {filterData: {...state.filterData, modello: action.modello}})
}

const setDeviceSuggestionLoading = (state, action) => {
    return updateObject(state, {deviceSuggestion: {...state.deviceSuggestion, loading: action.value}})
}

const setDeviceFilterSuggestionData = (state, action) => {
    return updateObject(state, {deviceSuggestion: {...state.deviceSuggestion, menuItems: action.suggestionList}});
}

const setWrenchLoadingDevice = (state, action) => {
    let tmpObj = {...state.device, wrenchLoading: action.value};
    if (action.value) {
        tmpObj = {...tmpObj, wrenchLoaded: false};
    }
    return updateObject(state, {device: tmpObj});
}

const setWrenchDetailsDevice = (state, action) => {
    let devices = [...state.device.data];
    let tmpDevices = [];
    devices.forEach(device => {
        let tmpWrenchDetails = action.wrenchDetails.find(d => d.objectId === device.imei);
        // delete tmpWrenchDetails.iccId;
        let tmpS = {...device, ...tmpWrenchDetails};
        tmpDevices.push(tmpS);
    });
    let tmpObj = {
        ...state.device,
        data: tmpDevices,
        wrenchLoaded: true
    };
    return updateObject(state, {device: tmpObj});
}

const updateActiveDeviceServiceRequest = (state, action) => {
    return updateObject(state,
        {
            activeServiceRequest: updateObject(state.activeServiceRequest,
                {[`${action.typeOf}`]: action.value})
        })
}

const changeTagsForDevice = (state, action) => {
    if (action.type === "data") {
        return updateObject(state, {
            collaborators: updateObject(state.collaborators, {[`${action.forType}`]: action.tags})
        });
    } else {
        return updateObject(state, {
            deviceSelectedRow: updateObject(state.deviceSelectedRow, {[`${action.forType}`]: action.tags})
        });
    }
}

const createNewTag = (state, action) => {
    return updateObject(state, {
        deviceSelectedRow: updateObject(state.deviceSelectedRow, {
            tagsForDeviceList: [...state.deviceSelectedRow.tagsForDeviceList, action.tag]
        })
    })
}

const updateCheckedTagsDevice = (state, action) => {
    const changedData = [...state.device.data]
    changedData.find(s => s.imei === action.imei).tags.tags = action.updatedTags
    let tmpData = {...state.device, data: changedData}
    return {...state, device: tmpData}

}

const setCollaboratrs = (state, action) => {
    return updateObject(state, {
        collaborators: updateObject(state.collaborators,
            {data: action.collaborators})
    })
}

const setLoadingCollaborators = (state, action) => {
    return updateObject(state, {
        collaborators: updateObject(state.collaborators,
            {loading: action.loading})
    })
}

const setErrorCollaborators = (state, action) => {
    return updateObject(state, {
        collaborators: updateObject(state.collaborators,
            {error: action.payload})
    })
}

const deleteTag = (state, action) => {
    const deviceWithUpdatedTags = state.device.data.map(device => {
        device.tags.tags = device.tags.tags.filter(tag => tag.label !== action.tagLabel)
        return device;
    })
    return updateObject(state, {device: {...state.device, data: deviceWithUpdatedTags}})
}

const editTag = (state, action) => {
    const deviceWithUpdatedTags = state.device.data.map(device => {
        device.tags.tags = device.tags.tags.map(tag => {
            if (tag.id === action.tagId) {
                tag.name = action.tagName;
                tag.color = action.tagColor;
            }
            return tag;
        })
        return device;
    })
    return updateObject(state, {device: {...state.device, data: deviceWithUpdatedTags}})
}

const clearSelectedRowForDevice = (state) => {
    return updateObject(state, {
        deviceSelectedRow: {
            tagsForDeviceList: [],
            firstRenderTags: []
        }
    })
}

const updateTagFilterAutocomplete = (state, action) => {
    return updateObject(state, {filterData: updateObject(state.filterData, {tags: action.payload})})
}

const setDownloadCsvLoading = (state, action) => {
    return updateObject(state, {downloadCsvLoading: action.payload})
}

const setDeviceAssociazioneKaskoCustom = (state, action) => {
    return updateObject(state, {
        kaskoData: updateObject(state.kaskoData, {
            tableData: action.tableData,
            maxToAssociate: action.maxToAssociate,
            currentAssociated: action.currentAssociated
        })
    })
}

const setDeviceKaskoLoading = (state, action) => {
    return updateObject(state, {kaskoData: updateObject(state.kaskoData, {tableLoading: action.value})})
}

const deviceReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_DEVICES:
            return setDeviceData(state, action);
        case actionTypes.SET_LOADING_DEVICES:
            return setLoadingDevices(state, action);
        case actionTypes.SET_LOADING_DEVICE_DETAILS:
            return setLoadingDeviceDetails(state, action);
        case actionTypes.SET_SELECTED_DEVICE:
            return setSelectedDevice(state, action);
        case actionTypes.SET_SORTING_DEVICE:
            return setSortingDevice(state, action);
        case actionTypes.CHANGE_FILTER_DEVICE:
            return changeFilter(state, action);
        case actionTypes.RESET_FILTER_DEVICE:
            return resetFilter(state, action);
        case actionTypes.DELETE_TAG_DEVICE:
            return deleteTag(state, action);
        case actionTypes.EDIT_TAG_DEVICE:
            return editTag(state, action);
        case actionTypes.SET_FILTER_CLICKED_DEVICE:
            return setFilterClicked(state, action);
        case actionTypes.SET_DEVICE_FILTER_LOADING_OR_ERROR:
            return setFilterLoadingOrError(state, action);
        case actionTypes.SET_DEVICE_FILTER_INPUT_DATA:
            return setFilterInputData(state, action);
        case actionTypes.UPDATE_MODELLO_SELECT:
            return updateModelloSelect(state, action);
        case actionTypes.SET_DEVICE_SUGGESTION_LOADING:
            return setDeviceSuggestionLoading(state, action);
        case actionTypes.SET_DEVICE_FILTER_SUGGESTION_DATA:
            return setDeviceFilterSuggestionData(state, action);
        case actionTypes.SET_WRENCH_LOADING_DEVICES:
            return setWrenchLoadingDevice(state, action);
        case actionTypes.SET_WRENCH_DETAILS_DEVICE:
            return setWrenchDetailsDevice(state, action);
        case actionTypes.SET_ACTIVE_DEVICE_SERVICE_REQUEST:
            return updateActiveDeviceServiceRequest(state, action);
        case actionTypes.CHANGE_TAGS_DEVICE:
            return changeTagsForDevice(state, action);
        case actionTypes.CREATE_TAG_DEVICE:
            return createNewTag(state, action);
        case actionTypes.UPDATE_CHANGED_TAGS_DEVICE:
            return updateCheckedTagsDevice(state, action);
        case actionTypes.GET_COLLABORATORS_DEVICE:
            return setCollaboratrs(state, action);
        case actionTypes.SET_LOADING_COLLABORATORS_DEVICE:
            return setLoadingCollaborators(state, action);
        case actionTypes.SET_ERROR_COLLABORATORS_DEVICE:
            return setErrorCollaborators(state, action);
        case actionTypes.CLEAR_SELECTED_ROW_DEVICE:
            return clearSelectedRowForDevice(state);
        case actionTypes.UPDATE_DEVICE_TAGS_AUTOCOMPLETE_SUCCESS:
            return updateTagFilterAutocomplete(state, action);
        case actionTypes.SET_DEVICE_CSV_DOWNLOAD_LOADING:
            return setDownloadCsvLoading(state, action)
        case actionTypes.SET_DEVICE_ASSOCIAZIONE_KASKO_CUSTOM:
            return setDeviceAssociazioneKaskoCustom(state, action)
        case actionTypes.SET_DEVICE_ASSOCIAZIONE_LOADING:
            return setDeviceKaskoLoading(state, action)
        default:
            return state;
    }
};

export default deviceReducer;
